import { Box, Button, Grid, MobileStepper, useTheme } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomTextField from "../../../CustomComponents/CustomTextField";
import { convertDateWithValidation, validate } from "../../helper/losDataHelper";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { useState } from "react";

const RCUDetails = ({ rcuDetailsList }) => {

  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);

 const maxSteps = validate(rcuDetailsList) ?  rcuDetailsList.length : 0;

 const handleBack = () => {
   setActiveStep((prevActiveStep) => prevActiveStep - 1);
 };

 const handleNext = () => {
   setActiveStep((prevActiveStep) => prevActiveStep + 1);
 };

  const rcuDetailsComponent = () => {
    const rcuDetails = validate(rcuDetailsList) ? rcuDetailsList[activeStep] : undefined;
    return(
      <Grid container rowSpacing={0} columnSpacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="Internal Application ID"
               variant="standard"
               placeholder="Enter Internal Application ID"
               disabled={true}
               value={rcuDetails !== undefined ? rcuDetails.internalApplicationId : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="Internal RCU ID"
               variant="standard"
               placeholder="Enter Internal RCU ID"
               disabled={true}
               value={rcuDetails !== undefined ? rcuDetails.internalRcuId : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="Application Number"
               variant="standard"
               placeholder="Enter Application Number"
               disabled={true}
               value={rcuDetails !== undefined ? rcuDetails.applicationNumber : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="Vendor Type ID"
               variant="standard"
               placeholder="Enter Vendor Type ID"
               disabled={true}
               value={rcuDetails !== undefined ? rcuDetails.vendorTypeId : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="Vendor Code"
               variant="standard"
               placeholder="Enter Vendor Code"
               disabled={true}
               value={rcuDetails !== undefined ? rcuDetails.vendorCode : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="Vendor Name"
               variant="standard"
               placeholder="Enter Vendor Name"
               disabled={true}
               value={rcuDetails !== undefined ? rcuDetails.vendorName : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="Vendor Mobile Number"
               variant="standard"
               placeholder="Enter Vendor Mobile Number"
               disabled={true}
               value={rcuDetails !== undefined ? rcuDetails.vendorMobileNumber : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="RCU File Status"
               variant="standard"
               placeholder="Enter RCU File Status"
               disabled={true}
               value={rcuDetails !== undefined ? rcuDetails.rcuFileStatus : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="RCU Sub Status"
               variant="standard"
               placeholder="Enter RCU Sub Status"
               disabled={true}
               value={rcuDetails !== undefined ? rcuDetails.rcuSubStatus : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="Comment"
               variant="standard"
               placeholder="Enter Comment"
               disabled={true}
               value={rcuDetails !== undefined ? rcuDetails.comment : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="Initiated Date"
               variant="standard"
               placeholder="Enter Initiated Date"
               disabled={true}
               value={validate(rcuDetails) ? convertDateWithValidation(rcuDetails.initiatedDate) : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="Response Date"
               variant="standard"
               placeholder="Enter Response Date"
               disabled={true}
               value={validate(rcuDetails) ? convertDateWithValidation(rcuDetails.responseDate) : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="Approved Date"
               variant="standard"
               placeholder="Enter Approved Date"
               disabled={true}
               value={validate(rcuDetails) ? convertDateWithValidation(rcuDetails.approvedDate) : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="Proof Document Name"
               variant="standard"
               placeholder="Enter Proof Document Name"
               disabled={true}
               value={rcuDetails !== undefined ? rcuDetails.proofDocumentName : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="Proof Document ID"
               variant="standard"
               placeholder="Enter Proof Document ID"
               disabled={true}
               value={rcuDetails !== undefined ? rcuDetails.proofDocumentId : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="RCU Document Name"
               variant="standard"
               placeholder="Enter RCU Document Name"
               disabled={true}
               value={rcuDetails !== undefined ? rcuDetails.rcuDocumentName : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="RCU Document ID"
               variant="standard"
               placeholder="Enter RCU Document ID"
               disabled={true}
               value={rcuDetails !== undefined ? rcuDetails.rcuDocumentId : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="Task Status"
               variant="standard"
               placeholder="Enter Task Status"
               disabled={true}
               value={rcuDetails !== undefined ? rcuDetails.taskStatus : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
               type="text"
               label="Internal RCU Performer"
               variant="standard"
               placeholder="Enter Internal RCU Performer"
               disabled={true}
               value={rcuDetails !== undefined ? rcuDetails.internalRcuPerformer : ""}
             />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Task State ID"
                variant="standard"
                placeholder="Enter Task State ID"
                disabled={true}
                value={rcuDetails !== undefined ? rcuDetails.taskStateId : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}> 
             <CustomTextField
                type="text"
                label="Task State"
                variant="standard"
                placeholder="Enter Task State"
                disabled={true}
                value={rcuDetails !== undefined ? rcuDetails.taskState : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Parent ID"
                variant="standard"
                placeholder="Enter Parent ID"
                disabled={true}
                value={rcuDetails !== undefined ? rcuDetails.parentId : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Created By"
                variant="standard"
                placeholder="Enter Created By"
                disabled={true}
                value={rcuDetails !== undefined ? rcuDetails.createdBy : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Modified By"
                variant="standard"
                placeholder="Enter Modified By"
                disabled={true}
                value={rcuDetails !== undefined ? rcuDetails.modifiedBy : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Created Date"
                variant="standard"
                placeholder="Enter Created Date"
                disabled={true}
                value={rcuDetails !== undefined ? convertDateWithValidation(rcuDetails.createdDate) : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Modified Date"
                variant="standard"
                placeholder="Enter Modified Date"
                disabled={true}
                value={rcuDetails !== undefined ? convertDateWithValidation(rcuDetails.modifiedDate) : ""}
              />
              </Grid>
          </Grid>
    );
  }

    return(<>
         <AccordianContainer
          id="accord"
          title="RCU Details"
          initialOpen={false}
        >
          <Box sx={{ marginTop: "-0.5%" }}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                         <Box sx={{ display: "flex", justifyContent:"center", alignItems: "center", marginBottom: "8px"}}>
                        { maxSteps > 1 && <MobileStepper
                          variant="text"
                          steps={maxSteps}
                          position="static"
                          activeStep={activeStep}
                          sx={{ maxWidth: 400, flexGrow: 1, boxShadow: 2 }} 
                            nextButton={
                            <Button size="small" sx={{ color:"#003f7c" }} onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                                Next
                            {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft />
                            ) : ( <KeyboardArrowRight /> )}
                           </Button>
                         }
                        backButton={
                        <Button size="small" onClick={handleBack} sx={{ color:"#003f7c" }} disabled={activeStep === 0}>
                        {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight />
                        ) : (
                            <KeyboardArrowLeft />
                        )}
                            Back
                        </Button>
                    }
                    /> }
                    </Box>
                    </Grid>
                    { rcuDetailsComponent() }
          </Box>
          </AccordianContainer>
    </>);
}

export default RCUDetails;